import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'styleguide/styleguide-ds2-output.css'
import React from 'react';
import { detectEnvironmentFromUrl, getEnvironmentConfig } from './utils/detectEnv';
import ReduxProvider from './store/ReduxProvider';
import { BrowserRouter } from 'react-router-dom';


console.log('React app starting...');

console.log('React app starting...');

// ============================================
// Detect Environment from URL
// ============================================

const detectedEnv = detectEnvironmentFromUrl();
const envConfig = getEnvironmentConfig();

console.log('Environment Detection:');
console.log(' Detected Environment:', detectedEnv);

// Store globally
(globalThis as any).detectedEnv = detectedEnv;
(globalThis as any).envConfig = envConfig;

ReactDOM.render(
 <React.StrictMode>
    <ReduxProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ReduxProvider>
  </React.StrictMode>,
  document.getElementById('root') as HTMLElement
);